export {};

declare global {
  interface String {
    contains(toFind: string, options?: { ignoreCase?: boolean }): boolean;
  }
}

String.prototype.contains = function (toFind, options): boolean {
  let currentStr = `${this}`;
  let toFindStr = `${toFind}`;

  if (options?.ignoreCase) {
    currentStr = currentStr.toLowerCase();
    toFindStr = toFindStr.toLowerCase();
  }

  return currentStr.includes(toFindStr);
};
